module.exports = __webpack_public_path__ + "img/114.51180a27.png";